import React, { FC } from 'react';
import { Label } from '../../TypographyNew';
import { Checkbox } from '../../Checkbox';
import { Button } from '../../Button';
import {
  DropdownItemConfirmationOptions,
  DropdownItemContainer,
} from './DropdownListItems.styles';
import {
  DropdownCheckboxItemProps,
  DropdownItemProps,
  DropdownItemWithConfirmationProps,
} from './DropdownListItems.types';
import { useDropdown } from '../DropdownHooks';

export const DropdownItem: FC<DropdownItemProps> = ({
  children,
  selected,
  onClick,
  ...props
}) => {
  const { toggle } = useDropdown();

  const handleClick = (e: React.MouseEvent) => {
    onClick?.(e);
    toggle(); // Close dropdown on item selection
  };
  return (
    <DropdownItemContainer selected={selected} onClick={handleClick} {...props}>
      <Label variant={1}>{children}</Label>
    </DropdownItemContainer>
  );
};

export const DropdownItemWithConfirmation: FC<
  DropdownItemWithConfirmationProps
> = ({ children, onConfirm, ...props }) => {
  const [isWaitingConfirmation, setIsWaitingConfirmation] =
    React.useState(false);
  const { toggle } = useDropdown();

  const handleItemClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsWaitingConfirmation(true);
  };

  const handleCancelClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsWaitingConfirmation(false);
  };

  const handleConfirm = () => {
    toggle();
    onConfirm();
  };
  return (
    <DropdownItemContainer
      {...props}
      onClick={handleItemClick as F0<React.MouseEvent>}
    >
      {isWaitingConfirmation ? (
        <DropdownItemConfirmationOptions>
          <Button
            variant={'secondary'}
            size={'small'}
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
          <Button variant={'danger'} size={'small'} onClick={handleConfirm}>
            {children}
          </Button>
        </DropdownItemConfirmationOptions>
      ) : (
        <Label variant={1}>{children}</Label>
      )}
    </DropdownItemContainer>
  );
};

export const DropdownCheckboxItem: FC<DropdownCheckboxItemProps> = ({
  selected,
  label,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };

  return (
    <DropdownItemContainer
      selected={selected}
      onClick={handleClick as F0<React.MouseEvent>}
    >
      <Checkbox checked={selected} label={label} />
    </DropdownItemContainer>
  );
};
